import ReactGoogleLogin, { GoogleLoginProps } from 'react-google-login';

const GoogleLogin = (props: GoogleLoginProps) => {
  return <ReactGoogleLogin {...props} />;
};

export default GoogleLogin;
